export default function getQueryParam(param: string, defaultValue?: string | number) {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.has(param) ? searchParams.get(param) : defaultValue;
}
